import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { I as IMask } from './index2.js';
import { d as defineCustomElement$3 } from './custom-popper2.js';
import { d as defineCustomElement$2 } from './form-control-error-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const NumberInputMasked = /*@__PURE__*/ proxyCustomElement(class NumberInputMasked extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.imask = null;
        this.initializeIMask = () => {
            if (!this.textInput)
                return;
            this.imask = IMask(this.textInput, {
                mask: this.mask,
            });
            this.imask.on('accept', () => {
                var _a;
                const rawValue = (_a = this.imask) === null || _a === void 0 ? void 0 : _a.unmaskedValue;
                if (rawValue !== undefined) {
                    this.inputHandler(this.name, rawValue);
                }
            });
            this.textInput.addEventListener('blur', () => this.formControlBlur.emit());
        };
        this.handleFormControlInput = (event) => {
            const target = event.target;
            const name = target.getAttribute('name');
            this.formControlInput.emit({ name: name, value: target.value });
        };
        this.updateInput = (newValue) => {
            if (this.imask && newValue) {
                this.imask.value = String(newValue);
            }
        };
        this.label = undefined;
        this.name = undefined;
        this.helpText = undefined;
        this.errorText = undefined;
        this.defaultValue = undefined;
        this.inputHandler = undefined;
        this.mask = undefined;
        this.disabled = undefined;
    }
    handleDefaultValueChange(newValue) {
        this.initializeIMask();
        this.updateInput(newValue);
    }
    disconnectedCallback() {
        var _a;
        (_a = this.imask) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    componentDidLoad() {
        if (this.textInput) {
            this.initializeIMask();
            this.updateInput(this.defaultValue);
        }
    }
    render() {
        return (h(Host, { key: 'ec5637a437fc6925f12ed0ff9653de16cebec6c8', exportparts: "label,input,input-invalid" }, h("div", { key: 'fa43aed393941aaa2c9aadf550e2528aca661c90', class: "form-group d-flex flex-column" }, h("div", { key: 'f97bc1662798dd0ac7a01050771f7e2d8b94d3c8', class: "d-flex align-items-start gap-2" }, h("label", { key: '75b17b73150c1c1ef3ca0489aa1dac45b86583b8', part: "label", class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: 'd1c35542ebf2c49de0abb0488dff23aad8238eaf', helpText: this.helpText })), h("input", { key: '3573366640ca5525b12cf086c92c000a25bfaf8b', ref: el => (this.textInput = el), id: this.name, name: this.name, onBlur: this.formControlBlur.emit, onInput: this.handleFormControlInput, part: `input ${this.errorText && 'input-invalid'}`, class: this.errorText ? 'form-control is-invalid' : 'form-control', type: "text", disabled: this.disabled }), h("form-control-error-text", { key: 'db11bee11d3f1f33ac03e8ed0f8687f0b9fff9cf', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-number-masked", {
        "label": [1],
        "name": [8],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "defaultValue": [1, "default-value"],
        "inputHandler": [16],
        "mask": [1],
        "disabled": [4]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-number-masked", "custom-popper", "form-control-error-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-number-masked":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, NumberInputMasked);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { NumberInputMasked as N, defineCustomElement as d };
